import { useTranslation } from "react-i18next";
import BoQAddDropdown from "./BoQAddDropdown";

/**
 * Empty state for BoQ editor: title, subtitle, Add dropdown (subgroup disabled when no group).
 */
const BoQEmptyState = ({
	onAddElement,
	canAddSubgroup = false,
}) => {
	const { t } = useTranslation();

	return (
		<div className="boq-editor-empty-state">
			<p className="boq-editor-empty-title">{t("boq.empty.title")}</p>
			<p className="boq-editor-empty-subtitle">{t("boq.empty.subtitle")}</p>
			<BoQAddDropdown
				className="boq-editor-empty-add"
				onAddElement={onAddElement}
				canAddSubgroup={canAddSubgroup}
				toggleVariant="primary"
			/>
		</div>
	);
};

export default BoQEmptyState;
